/* eslint-disable import/prefer-default-export */
export const MAIL_URL = `${process.env.REACT_APP_FUNCTIONS_URL}/mailerSend`
export const GET_CONTACTS_URL = `${process.env.REACT_APP_FUNCTIONS_URL}/contactListGet`
export const CREATE_BILL = `${process.env.REACT_APP_FUNCTIONS_URL}/paymentsCreateBill`
export const CREATE_TICKET = `${process.env.REACT_APP_FUNCTIONS_URL}/paymentsCreateTicket`
export const GET_BILLS = `${process.env.REACT_APP_FUNCTIONS_URL}/paymentsGetBills`
